// Registro central de inscricoes de canal do Echo/Reverb. Evita assinar o
// mesmo canal duas vezes quando um componente remonta (troca de rota) e
// centraliza o "sair de tudo" no logout/troca de tela - sem isso, canal
// vaza entre navegacoes (ver Fase 3, plataforma do front no plano).
const canaisAtivos = {}

export function inscreverPrivado(nomeCanal) {
  if (!canaisAtivos[nomeCanal]) {
    canaisAtivos[nomeCanal] = window.Echo.private(nomeCanal)
  }
  return canaisAtivos[nomeCanal]
}

export function inscreverPresenca(nomeCanal) {
  if (!canaisAtivos[nomeCanal]) {
    canaisAtivos[nomeCanal] = window.Echo.join(nomeCanal)
  }
  return canaisAtivos[nomeCanal]
}

export function sairDoCanal(nomeCanal) {
  if (canaisAtivos[nomeCanal]) {
    window.Echo.leave(nomeCanal)
    delete canaisAtivos[nomeCanal]
  }
}

export function sairDeTudo() {
  Object.keys(canaisAtivos).forEach(sairDoCanal)
}
